import { apiCustomZones } from '@spo/services/api';
import { SpoCustomZonesResponse } from '@spo/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const useCustomZones = (customZonesIds: string[]) => {
  const formatCzDisplay = (data: SpoCustomZonesResponse | undefined) => {
    if (data) {
      return data
        .map((cz) => {
          const country = cz.designation.replace('CZ ', '').toLocaleLowerCase();
          return country.charAt(0).toLocaleUpperCase() + country.slice(1);
        })
        .sort((a: string, b: string) => a.localeCompare(b));
    }
    return [];
  };

  return useQuery({
    queryKey: ['useCustomZones', customZonesIds],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiCustomZones.getCustomZonesByIds({
          customZonesIds,
          language: 'EN',
        });
        return response;
      }
    },
    placeholderData: keepPreviousData,
    enabled: customZonesIds.length > 0,
    select: (data) => formatCzDisplay(data),
  });
};
